import React from 'react'
import { Outlet } from 'react-router-dom'
import { config } from '../../config'
import { useTgWebAppSdk } from './useTgWebApp'

const TELEGRAM_BOT_URL=`https://t.me/${config.TG_BOT_NAME}`

export const TgWebAppWrapper: React.FC = () => {
  const {isWebAppReady} =useTgWebAppSdk(TELEGRAM_BOT_URL as string)
  return isWebAppReady? <Outlet />: null
}

